import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@ui/button/Button';
import { AccordionStepsActionTypes } from '@state/features/common.types';
const ConnectivityCheckoutStepLineData = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { coverageAddress, registry } = useSelector((state) => state.connectivity);
    useEffect(() => {
        if (!registry) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'personalData' });
        }
    }, []);
    if (!coverageAddress) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "checkout-connectivity--linedata" },
        React.createElement("div", { className: 'checkout-connectivity-line' },
            React.createElement("p", { className: 'checkout-step-description' }, t('connectivity.checkout.linedata.description')),
            React.createElement("div", { className: 'coverage-address--container' },
                React.createElement("p", { className: 'coverage-address--text' },
                    React.createElement("span", { className: 'label' }, t('connectivity.checkout.linedata.address.label')),
                    React.createElement("span", { className: 'value' },
                        coverageAddress.region,
                        ", ",
                        coverageAddress.city,
                        ", ",
                        coverageAddress.stateCode,
                        ", ",
                        coverageAddress.address))),
            React.createElement("div", { className: 'checkout-navigations' },
                React.createElement(Button, { type: "button", cls: ['cta-primary'], isAnimated: true, onClick: () => dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'payment' }) },
                    React.createElement("span", null, t('common.proceed')))))));
};
export default ConnectivityCheckoutStepLineData;
